<template>
  <div class="ui-main">
    <a-spin :spinning="loading" size="large">
      <a-form ref="formRef" :model="modelRef" @finish="onSubmit">

        <a-form-item name="ticketSystem" v-bind="formItemLayout" label="售票系统类型" required :rules="[{required: true, message: '必填项不允许为空'}]" extra="默认凤凰佳影">
          <a-select v-model:value="modelRef.ticketSystem" @change="onSystemChange">
            <a-select-option :value="1">凤凰佳影</a-select-option>
            <a-select-option :value="2">辰星</a-select-option>
            <a-select-option :value="3">中瑞</a-select-option>
            <a-select-option :value="5">凤凰云智</a-select-option>
            <a-select-option :value="4">辰星4.0</a-select-option>
            <a-select-option :value="6">云端云智</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item name="name" v-bind="formItemLayout" :label="labelConfig.name" required :rules="[{required: true, message: '必填项不允许为空'}]" extra="自定义的，基本是影城的名称，需要是唯一的">
          <a-input v-model:value="modelRef.name" />
        </a-form-item>

        <a-form-item name="username" v-bind="formItemLayout" :label="labelConfig.username" required :rules="[{required: true, message: '必填项不允许为空'}]" extra="佳影默认gvdba，辰星默认upss，如果有特殊的，阿杜肯定会讲">
          <a-input v-model:value="modelRef.username" />
        </a-form-item>

        <a-form-item name="password" v-bind="formItemLayout" :label="labelConfig.password" required :rules="[{required: true, message: '必填项不允许为空'}]" extra="佳影默认manager，辰星默认Ticketupss，如果有特殊的，阿杜肯定会讲">
          <a-input
            v-model:value="modelRef.password"
          />
        </a-form-item>

        <a-form-item name="url" v-bind="formItemLayout" :label="labelConfig.url" required :rules="[{required: true, message: '必填项不允许为空'}]" :extra="labelConfig.urlTips">
          <a-input v-if="modelRef.ticketSystem == 1" v-model:value="modelRef.url" addon-before="jdbc:oracle:thin:@" addon-after=":1521:GVDB" />
          <a-input v-if="modelRef.ticketSystem == 2" v-model:value="modelRef.url" placeholder="ip:port" addon-before="jdbc:mysql://">
            <template #addonAfter>
              <div style="width: 120px;text-overflow: ellipsis;white-space:nowrap;overflow:hidden;">/CMS?connectTimeout=10000&socketTimeout=60000&allowMultiQueries=true&autoReconnect=true&useUnicode=true&characterEncoding=utf8&useSSL=false&serverTimezone=Asia/Shanghai</div>
            </template>
          </a-input>
          <a-input v-if="modelRef.ticketSystem == 3" v-model:value="modelRef.url" placeholder="请输入影院编码"/>
          <a-input v-if="modelRef.ticketSystem == 4" v-model:value="modelRef.url" placeholder="请输入接口地址"/>
          <a-input v-if="modelRef.ticketSystem == 5" v-model:value="modelRef.url" placeholder="请输入接口地址"/>
          <a-input v-if="modelRef.ticketSystem == 6" v-model:value="modelRef.url" placeholder="请输入接口地址"/>
        </a-form-item>

        <a-form-item name="driver" v-bind="formItemLayout" :label="labelConfig.driver" required :rules="[{required: true, message: '必选项不允许为空'}]" extra="佳影和辰星不用改" v-if="labelConfig.driver">
          <a-input v-model:value="modelRef.driver"/>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 12, offset: 6 }">
          <a-button type="primary" html-type="submit" :loading="loading">提交</a-button>
        </a-form-item>
      </a-form>
    </a-spin>
  </div>
</template>

<script>
  // import * as systemApi from '@/service/modules/system';
  import { addDataSourceList } from "@/service/modules/cinema";
  export default {
    props: {
      isEdit: {      // true :编辑  false: 新增
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        loading: false,
        id: 0,
        modelRef: {
          name: '',
          username: 'gvdba',
          password: 'manager',
          url: '',
          driver: 'oracle.jdbc.OracleDriver',
          ticketSystem: 1
        },
        form: null,
        isParent: 0,
        formItemLayout: {
          labelCol: { span: 6 },
          wrapperCol: { span: 14 },
        },
        menus: [],
        menusTwo: [],
        menusThird: [],
        labelConfig: {
          name: '',
          username: '',
          password: '',
          url: '',
          driver: '',
        },
      }
    },
    created() {
      // if (this.isEdit && this.$route.query.id) {
      //     this.id = this.$route.query.id;
      //     this.getData();
      // }
    },
    watch: {
      'modelRef.ticketSystem':{
        handler(val) {
          console.log(val)
          if (val == 1) {
            this.labelConfig.name = '数据池名称';
            this.labelConfig.username = '用户名';
            this.labelConfig.password = '密码';
            this.labelConfig.url = '链接URL';
            this.labelConfig.driver = '数据库连接类型';
            this.labelConfig.urlTips = 'ip';
          } else if (val == 2) {
            this.labelConfig.name = '数据池名称';
            this.labelConfig.username = '用户名';
            this.labelConfig.password = '密码';
            this.labelConfig.url = '链接URL';
            this.labelConfig.driver = '数据库连接类型';
            this.labelConfig.urlTips = '';
          } else if (val == 3) {
            this.labelConfig.name = '影院名称';
            this.labelConfig.username = '接口账号';
            this.labelConfig.password = '接口密钥';
            this.labelConfig.url = '影院编码';
            this.labelConfig.driver = 'API地址';
            this.labelConfig.urlTips = 'ip';
            this.modelRef.name = '';
            this.modelRef.username = '';
            this.modelRef.password = '';
            this.modelRef.url = '';
            // this.modelRef.driver = '';
          } else if (val == 5) {
            this.labelConfig.name = '影院名称';
            this.labelConfig.username = '渠道编码';
            this.labelConfig.password = '渠道密钥';
            this.labelConfig.url = '接口地址';
            this.labelConfig.urlTips = '生产环境:https://mcop-lark.yuekeyun.com/route2; 测试环境:http://mcop-lark.yuekeyun.com/route2';
            this.labelConfig.driver = '';
            this.modelRef.name = '';
            this.modelRef.username = '';
            this.modelRef.password = '';
            this.modelRef.url = 'https://mcop-lark.yuekeyun.com/route2';
            this.modelRef.driver = '';
          } else if (val == 4) {

          } else if (val == 6) {
            this.labelConfig.name = '影院名称';
            this.labelConfig.username = '租户编码';
            this.labelConfig.password = '接口加密盐';
            this.labelConfig.url = '影院编码';
            this.labelConfig.driver = '接口地址';
            this.labelConfig.urlTips = '';
            this.modelRef.name = '';
            this.modelRef.username = '';
            this.modelRef.password = '';
            this.modelRef.url = '';
            this.modelRef.driver = '';

          }
        },
        immediate: true
      }
    },
    methods: {
      onSystemChange(e) {
        if (e == 1) {
          this.modelRef.driver = 'oracle.jdbc.OracleDriver'
          this.modelRef.username = 'gvdba';
          this.modelRef.password = 'manager';
        } else if (e == 2) {
          this.modelRef.driver = 'com.mysql.cj.jdbc.Driver'
          this.modelRef.username = 'upss';
          this.modelRef.password = 'Ticketupss';
        }
      },
      onSubmit() {
        // if (this.isEdit) {
        //   addDataSource(this.modelRef).then(res => {
        //         if (res.code == 200){
        //             this.$message.success('操作成功');
        //             this.$closePage(this.$router.currentRoute.value, '/systemRoot/dataSource/index');
        //         }
        //     })
        // } else {
        if (this.modelRef.ticketSystem == 1) {
          this.modelRef.url ='jdbc:oracle:thin:@' + this.modelRef.url +':1521:GVDB'
        } else if (this.modelRef.ticketSystem == 2) {
          this.modelRef.url ='jdbc:mysql://' + this.modelRef.url +'/CMS?connectTimeout=10000&socketTimeout=60000&allowMultiQueries=true&autoReconnect=true&useUnicode=true&characterEncoding=utf8&useSSL=false&serverTimezone=Asia/Shanghai'
        }

        addDataSourceList(this.modelRef).then(res => {
          if (res.code == 200){
            this.$message.success('操作成功');
            this.$closePage(this.$router.currentRoute.value, '/cinema/basis/dbsource/list');
          }
        }).catch(() => {})
      },
      // getData() {
      //     this.loading = true;
      //     systemApi.menuDetail({
      //         id: this.id
      //     }).then(res => {
      //         this.loading = false;
      //         if (res.code == 200) {
      //             let parent = res.data.routing.split(',') || [];
      //             this.modelRef = {
      //                 isParent: res.data.isParent ? true : false,
      //                 titleDecorator: res.data.title,
      //                 descriptionDecorator: res.data.description,
      //                 sortDecorator: res.data.sort,
      //                 url: res.data.url,
      //                 parentUrl: parent.length > 1 ? parent[0] : undefined,
      //                 parentTwoUrl: parent.length > 2 ? parent[1] : undefined,
      // 	parentThirdUrl: parent.length > 3 ? parent[2] : undefined,
      //             }
      //
      //         }
      //     })
      // }
    }
  }
</script>

<style scoped>
    .ui-main {
        width: 700px;
        text-align: left;
    }
</style>
